package com.nonopn.skywatcher.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.pages.sentinels.LoadDetectionScreen
import eu.codlab.navigation.NavBackStackEntryWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteNoThunderDetectionSelected : RouteParameterTo

object RouterNoThunderDetectionSelected : RouterNoParameters<RouteNoThunderDetectionSelected> {
    override val klass = RouteNoThunderDetectionSelected::class

    override fun navigateTo() = NavigateTo(
        route = RouteNoThunderDetectionSelected,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteNoThunderDetectionSelected

    override fun route(navBackStackEntry: NavBackStackEntryWrapper) =
        RouteNoThunderDetectionSelectedImpl()

    override fun isMatching(route: String) = route == "/"

    override fun navigateFrom(path: String) = RouteNoThunderDetectionSelected
}

class RouteNoThunderDetectionSelectedImpl : Route<RouteNoThunderDetectionSelected>(
    route = "/",
    params = RouteNoThunderDetectionSelected,
) {
    @Composable
    override fun scene() {
        LoadDetectionScreen(Modifier.fillMaxSize())
    }
}
